import i18next from "i18next";
import { DEFAULT_LOCALE, DEFAULT_NS, LANGUAGES } from "../constants.js";
import { RESOURCES } from "../resources.js";
const loadLocale = async (language, namespace) => {
  return RESOURCES[language][namespace];
};
const AskableResources = {
  type: "backend",
  init: (_, __, i18nextOptions) => {
    i18nextOptions.lng = i18nextOptions.lng || DEFAULT_LOCALE;
    i18nextOptions.ns = i18nextOptions.ns || [DEFAULT_NS];
    i18nextOptions.defaultNS = i18nextOptions.ns || [DEFAULT_NS];
    i18nextOptions.fallbackNS = i18nextOptions.fallbackNS || DEFAULT_NS;
    i18nextOptions.fallbackLng = DEFAULT_LOCALE;
    i18nextOptions.saveMissing = true;
    i18nextOptions.initAsync = false;
    i18nextOptions.preload = [DEFAULT_LOCALE];
    i18nextOptions.partialBundledLanguages = true;
    i18nextOptions.missingKeyHandler = (_2, ns, key) => {
      if (!i18next.hasLoadedNamespace(ns)) {
        console.error(
          `[@askableorg/i18n] namespace ${ns} is trying to be used, but has not been loaded for key ${key}`
        );
        return;
      }
      console.error(`[@askableorg/i18n] ${key} is missing in namespace ${ns}`);
    };
    i18nextOptions.backend = {
      loadPath: "./locales/{{lng}}/{{ns}}.json"
    };
  },
  read: (language, namespace, callback) => {
    loadLocale(language, namespace).then((res) => callback(null, res)).catch((err) => callback(err, null));
  }
};
export {
  AskableResources,
  DEFAULT_LOCALE,
  DEFAULT_NS,
  LANGUAGES as supportedLanguages
};
//# sourceMappingURL=i18next.js.map